import { Button } from "@ttc3k/trekker";
import { useRef } from "react";
import { Flex } from "styled-system/jsx";
import { WhereaboutsModal } from "shared/components";
import { InvoiceJournalContent } from "./InvoiceJournalContent";

type Props = {
  isOpen: boolean;
  onClose: () => void;
  paymentRequestId?: string | null;
  onChanged?: () => void | Promise<void>;
};

export const InvoiceJournalModal = ({
  isOpen,
  onClose,
  paymentRequestId,
  onChanged,
}: Props) => {
  // Defer notifying the parent about changes until the journal modal closes,
  // so parent refetches can't unmount/close the modal right after a void.
  const hasPendingChangesRef = useRef(false);

  const handleClose = () => {
    onClose();
    if (hasPendingChangesRef.current) {
      hasPendingChangesRef.current = false;
      void onChanged?.();
    }
  };

  return (
    <WhereaboutsModal
      isOpen={isOpen}
      onClose={handleClose}
      isMaxZIndex
      title="Invoice journal"
      description="Immutable invoice, payment, email, and accounting history."
      customFooter={
        <Flex
          px={{ base: "300", md: "500" }}
          py={{ base: "300", md: "400" }}
          justifyContent="flex-end"
        >
          <Button size="lg" visual="primary" mode="light" onClick={handleClose}>
            Close
          </Button>
        </Flex>
      }
    >
      <InvoiceJournalContent
        paymentRequestId={paymentRequestId}
        skip={!isOpen}
        onVoided={() => {
          hasPendingChangesRef.current = true;
        }}
      />
    </WhereaboutsModal>
  );
};
